/*
 * Copyright (c) 2020
 *    Reliant Business Valuation, LLC - http://reliantvalue.com
 *    Author: Kirill Vizniuk - kirill@internalvaluation.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import { Component, ComponentFactoryResolver, ComponentRef, HostListener, Input, ViewChild, ViewContainerRef } from '@angular/core';
import { FieldContextMenuComponent } from '../field-context-menu/field-context-menu.component';
import { Subscription } from 'rxjs';
import { Report } from 'src/app/model';
import { MenuItem } from 'src/app/model/menu-item';
import { RightMenuService } from 'src/app/services';
@Component({
  selector: 'right-click-menu',
  templateUrl: 'field-context-menu-wrapper.component.html',
  styleUrls: ['field-context-menu-wrapper.component.scss']
})
export class FieldContextMenuWrapperComponent {
  @ViewChild('target', { read: ViewContainerRef, static: false}) target: ViewContainerRef;

  @Input() report: Report;
  @Input() menuItems: MenuItem[];

  private contextMenuVisible = false;
  private tooltip: ComponentRef<any>;
  menuIDSubscription: Subscription;
  menuID:number = Math.random();

  constructor(
    private viewContainerRef: ViewContainerRef,
    private resolver: ComponentFactoryResolver,
    private rightMenuService: RightMenuService,
  ) {
    this.menuIDSubscription = this.rightMenuService.getRightMenuID().subscribe(step => {
      if (step) {
        if(this.menuID != step.ID)
          this.hideInfo();
      }
    });
  }

  /**
   * When clicking on field to open right click menu
   */
  onFieldLabelRightClick(): boolean {
    if (this.contextMenuVisible)
      return false;

    this.rightMenuService.sendRightMenuID(this.menuID);
    this.contextMenuVisible = true;
    const factory = this.resolver.resolveComponentFactory(FieldContextMenuComponent);
    this.tooltip = this.target.createComponent(factory);
    this.tooltip.instance.hostElement = this.viewContainerRef.element.nativeElement;

    // If want to show menu dynamic, then add your code here (based on menu type)
    for(let menu of this.menuItems){
      switch(menu.action){
        default:
          break;
      }
    }

    this.tooltip.instance.menuItems = this.menuItems;
    this.tooltip.instance.report = this.report;

    return true;
  }

  /**
   * If Right click menu is open and user clicks anywhere then hide it
   * @param targetElement
   */
  @HostListener('document:click', ['$event.target'])
  clickedOutside(targetElement: any): void {
    if(this.target){
      const clickedInside = this.target.element.nativeElement.contains(targetElement);
      if (!clickedInside) {
        this.hideInfo();
      }
    }
  }

  hideInfo(): void {
    if (!this.contextMenuVisible)
      return;

    this.contextMenuVisible = false;
    if (this.tooltip)
      this.tooltip.destroy();
  }
}

